<template>
    <div class="index">
       
        <div class="title">
            <img src="../../assets/images/logo.png" alt="">
            恋TA官方充值通道
            <!-- （点击进入下载官网） -->
        </div>
        <div class="header" v-if="token">
            <div class="header-l">
                <img :src="userInfo.header" alt="">
                {{userInfo.nickName}}
                <img src="../../assets/images/vip.png" alt="" class="icon" v-if="userInfo.memberType==1">
                <img src="../../assets/images/svip.png" alt="" class="icon" v-if="userInfo.memberType==2">
            </div>
            <van-button color="#FE4465" @click="close" style="margin-right: 20px;">切换账号</van-button>
        </div>
        <div class="input" v-if="!token">
            <div class="input-l">
                <van-field
                    v-model="phone"
                    placeholder="请输入手机号码"
                />
                <!-- <div :class="captchaFont=='获取图形验证码'? 'input-code input-code-s':'input-code'">
                    <div class="input-code-l">
                        <van-field
                            v-model="imageCode"
                            placeholder="请输入图形验证码"
                        />
                    </div>
                    <img :src="imageCodeUrl" mode="" class="item-code-img" @click="getImageCode('')" v-if="imageCodeUrl"/>
                    <van-button color="#FE4465" @click="getImageCode('')" class="codebtn" style="font-size: 12px;padding: 0 10px;" v-else>获取图形验证码</van-button>
                </div> -->
                <div :class="captchaFont=='获取验证码'? 'input-code input-code-s':'input-code'">
                    <div class="input-code-l">
                        <van-field
                            v-model="code"
                            placeholder="请输入验证码"
                        />
                    </div>
                    <van-button color="#FE4465" @click="captchaButtonClick" class="codebtn">{{captchaFont}}</van-button>
                </div>
            </div>
            
            <van-button color="#FE4465" @click="login">登录账号</van-button>
        </div>
        <div class="line"></div>
        <div class="tip">
            <div class="t-item">
                <span>尊享标识</span>
                VIP专属标识
            </div>
            <div class="t-item">
                <span>免广告特权</span>
                专享免广告权益
            </div>
            <div class="tip-line"></div>
            <div class="t-item">
                <span>超级曝光</span>
                牵手几率加倍
            </div>
            <div class="t-item">
                <span>更多功能</span>
                更多VIP专属功能
            </div>
            
        </div>
        <div class="line"></div>
        <div class="vip">
            <div class="vip-title">
                <div :class="vipIndex==0?'vip-title-s':'vip-title-i'" @click="vipIndexChange(0)">普通会员</div>
                <div :class="vipIndex==1?'vip-title-s':'vip-title-i'" @click="vipIndexChange(1)">尊享会员(推荐)</div>
                <div :class="vipIndex==2?'vip-title-s':'vip-title-i'" @click="vipIndexChange(2)">恋豆充值</div>
            </div>

            <div class="vip-content">
                <div :class="selectIndex==index?'vip-item vip-item-this':'vip-item'" v-for="(item,index) in vipList" :key="index" @click="selectVIP(index)" v-if="(item.memberType == 1&&vipIndex==0)||(item.memberType == 2&&vipIndex==1)">
                    <div class="vip-item1">
                        {{item.memberTime}}
                    </div>
                    <div class="vip-item2">
                        {{item.amount}}元
                    </div>
                    
                    <div class="vip-item3">
                        {{item.dayAmount}}/天
                    </div>
                    <div class="vip-item4" v-if="item.isTuiJian">
                        推荐选择
                    </div>
                </div>
                
                <div :class="selectIndex==index?'vip-item vip-item-this':'vip-item'" v-for="(item,index) in liandouList" :key="index" @click="selectVIP(index)" v-if="vipIndex==2">
                    <div class="vip-item1">
                        {{item.num}}恋豆
                    </div>
                    <div class="vip-item2">
                        {{item.price}}元
                    </div>
                  
                </div>
                
            </div>
        </div>
        <div class="line"></div>

        <div class="pay">
            <div class="pay-title">
                <div class="pay-line"></div>
                支付方式
                <div class="pay-line"></div>
            </div>
            <div class="pay-content">
                <van-radio-group :value="radio" @change="onChange">
                    <van-cell-group>
                        <van-cell data-name="2" @click="onClick('2')">
                            <div class="pay-l">
                                <img src="../../assets/images/icon02.png" alt="">
                                支付宝支付
                            </div>
                            <van-radio slot="right-icon" name="2" />
                        </van-cell>
                    </van-cell-group>
                    <van-cell data-name="1" @click="onClick('1')">
                        <div class="pay-l">
                            <img src="../../assets/images/icon01.png" alt="">
                            微信支付
                        </div>
                        <van-radio slot="right-icon" name="1" />
                    </van-cell>
                </van-radio-group>
            </div>
            <div class="line"></div>
        </div>

        <div class="vip-title" style="color:#333333;margin-bottom: 0;">
            <div class="vip-line"></div>
            权益对比
            <div class="vip-line"></div>
        </div>
        <div class="tabel" v-if="vipIndex!=2">
            <div class="tr">
                <div class="th">
                    用户权限
                </div>
                <div :class="selectIndex==null?'th th-this':'th'">
                    非会员
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'th th-this':'th'" v-show="vipIndex==0">
                    普通会员
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'th th-this':'th'" v-show="vipIndex==1">
                    尊享会员
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    广告权限
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <!-- 有广告 -->
                    {{vipEquityList[0].adPermissions}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <!-- 极少 -->
                    {{vipEquityList[1].adPermissions}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <!-- 免广告 -->
                    {{vipEquityList[2].adPermissions}}
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    尊享标识
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].exclusiveLogo}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <!-- {{vipEquityList[1].exclusiveLogo}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/index/vip1.png" mode="aspectFill" class="vipicon"/>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <!-- {{vipEquityList[2].exclusiveLogo}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/index/svip.png" mode="aspectFill" class="vipicon"/>
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    优先推荐
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].youXianTuiJian}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    {{vipEquityList[1].youXianTuiJian}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    {{vipEquityList[2].youXianTuiJian}}
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    高级筛选
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[0].gaoJiShaiXuan"/>
                    {{vipEquityList[0].gaoJiShaiXuan?'':'—'}}
                    <!-- {{vipEquityList[0].gaoJiShaiXuan?'√':'—'}} -->
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].gaoJiShaiXuan"/>
                    {{vipEquityList[1].gaoJiShaiXuan?'':'—'}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].gaoJiShaiXuan"/>
                    {{vipEquityList[2].gaoJiShaiXuan?'':'—'}}
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    亲密提升
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].qinMinTiSheng==1?'—':''}}{{vipEquityList[0].qinMinTiSheng==2?'双倍加成':''}}{{vipEquityList[0].qinMinTiSheng==3?'三倍加成':''}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    {{vipEquityList[1].qinMinTiSheng==1?'—':''}}{{vipEquityList[1].qinMinTiSheng==2?'双倍加成':''}}{{vipEquityList[1].qinMinTiSheng==3?'三倍加成':''}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    {{vipEquityList[2].qinMinTiSheng==1?'—':''}}{{vipEquityList[2].qinMinTiSheng==2?'双倍加成':''}}{{vipEquityList[2].qinMinTiSheng==3?'三倍加成':''}}
                </div>
            </div>
            
            <div class="tr tr2">
                <div class="td td2">
                    推荐资料
                </div>
                <div :class="selectIndex==null?'td2 td2-this':'td2'">
                    {{vipEquityList[0].findUserInfoAdsStr}}
                    <!-- {{userInfo.gender==1?10:20}}个/广告 -->
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td2 td2-this':'td2'" v-show="vipIndex==0">
                    <!-- {{vipEquityList[1].findUserInfoAdsStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].findUserInfoAdsStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[1].findUserInfoAdsStr}}
                    </div>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td2 td2-this':'td2'" v-show="vipIndex==1">
                    <!-- {{vipEquityList[2].findUserInfoAdsStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].findUserInfoAdsStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].findUserInfoAdsStr}}
                    </div>
                </div>
            </div>
            <div class="tr">
                <div class="td tdh2">
                    主动招呼
                </div>
                <div :class="selectIndex==null?'td tdh2 td-this':'td tdh2'">
                    <!-- {{vipEquityList[0].zhuDongZhaoHuStr}} -->
                    <div class="tdh2-i">
                        {{vipEquityList[0].zhuDongZhaoHuStr}}
                        <span>(未实名,每日{{vipEquityList[0].zhuDongZhaoHu}}次)</span>
                    </div>
                    <div class="tdh2-line">
                        
                    </div>
                    <div class="tdh2-i">
                        {{vipEquityList[0].realNameZhuDongZhaoHuStr}}
                        <span>(认证后,每日{{vipEquityList[0].realNameZhuDongZhaoHu}}次)</span>
                    </div>
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td tdh2 td-this':'td tdh2'" v-show="vipIndex==0">
                    {{vipEquityList[1].zhuDongZhaoHuStr}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td tdh2 td-this':'td tdh2'" v-show="vipIndex==1">
                    <!-- {{vipEquityList[2].zhuDongZhaoHuStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].zhuDongZhaoHuStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].zhuDongZhaoHuStr}}
                    </div>
                </div>
            </div>
            <div class="tr tr2">
                <div class="td tdh2 td2">
                    聊天消息
                </div>
                <div :class="selectIndex==null?'td2 tdh2 td2-this':'td2 tdh2'">
                    <!-- {{vipEquityList[0].chatMsgStr}} -->
                    <!-- {{userInfo.gender==1?4:6}}条消息/广告 -->
                    <div class="tdh2-i">
                        {{vipEquityList[0].chatMsgStr}}
                        <span>(未实名)</span>
                    </div>
                    <div class="tdh2-line">
                        
                    </div>
                    <div class="tdh2-i">
                        {{vipEquityList[0].realNameChatMsgStr}}
                        <span>(实名认证后)</span>
                    </div>
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td2 tdh2 td2-this':'td2 tdh2'" v-show="vipIndex==0">
                    <!-- {{vipEquityList[1].chatMsgStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].chatMsgStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[1].chatMsgStr}}
                    </div>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td2 tdh2 td2-this':'td2 tdh2'" v-show="vipIndex==1">
                    <!-- {{vipEquityList[2].chatMsgStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].chatMsgStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].chatMsgStr}}
                    </div>
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    动态发送
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].dynamicStr}}
                    
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <!-- {{vipEquityList[1].dynamicStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].dynamicStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[1].dynamicStr}}
                    </div>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <!-- {{vipEquityList[2].dynamicStr}} -->
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].dynamicStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].dynamicStr}}
                    </div>
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    访客查看
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].visitorStr}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].visitorStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[1].visitorStr}}
                    </div>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].visitorStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].visitorStr}}
                    </div>
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    心动查看
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].visitorStr}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].visitorStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[1].visitorStr}}
                    </div>
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].visitorStr=='√'"/>
                    <div v-else>
                        {{vipEquityList[2].visitorStr}}
                    </div>
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    语音发送
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[0].sendSpeech"/>
                    {{vipEquityList[0].sendSpeech?'':'—'}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].sendSpeech"/>
                    {{vipEquityList[1].sendSpeech?'':'—'}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].sendSpeech"/>
                    {{vipEquityList[2].sendSpeech?'':'—'}}
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    图片发送
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[0].sendImage"/>
                    {{vipEquityList[0].sendImage?'':'—'}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].sendImage"/>
                    {{vipEquityList[1].sendImage?'':'—'}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].sendImage"/>
                    {{vipEquityList[2].sendImage?'':'—'}}
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    定位发送
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[0].sendLocation"/>
                    {{vipEquityList[0].sendLocation?'':'—'}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].sendLocation"/>
                    {{vipEquityList[1].sendLocation?'':'—'}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].sendLocation"/>
                    {{vipEquityList[2].sendLocation?'':'—'}}
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    访客记录
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].visitorDay}}天
                    <!-- <img src="https://liantaapi.lianta520.com/static/images/gou1.png" mode="" v-if="vipEquityList[0].visitorStr"></img>
                    {{vipEquityList[0].visitorStr?'':'—'}} -->
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    {{vipEquityList[1].visitorDay}}天
                    <!-- <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].visitorStr"></img>
                    {{vipEquityList[1].visitorStr?'':'—'}} -->
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    {{vipEquityList[2].visitorDay}}天
                    <!-- <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].visitorStr"></img>
                    {{vipEquityList[2].visitorStr?'':'—'}} -->
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    实名认证
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].realName==0?'免费实名':'单独计费'}}
                    <span v-if="vipEquityList[0].realName">({{vipEquityList[0].realName}}恋豆)</span>
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    {{vipEquityList[1].realNameStr}}
                    <!-- {{vipEquityList[1].realName?'免费实名':'单独计费'}}
                    <text v-if="!vipEquityList[1].realName">(20恋豆)</text> -->
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    {{vipEquityList[1].realNameStr}}
                </div>
            </div>
            <div class="tr tr2">
                <div class="td">
                    其他认证
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    {{vipEquityList[0].otherRealStr}}
                    <span v-if="vipEquityList[0].otherReal">({{vipEquityList[0].otherReal}}恋豆)</span>
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    {{vipEquityList[1].otherRealStr}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    {{vipEquityList[2].otherRealStr}}
                </div>
            </div>
            <div class="tr">
                <div class="td">
                    专属客服
                </div>
                <div :class="selectIndex==null?'td td-this':'td'">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[0].customer"/>
                    {{vipEquityList[0].customer?'':'—'}}
                </div>
                <div :class="vipIndex==0&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==0">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[1].customer"/>
                    {{vipEquityList[1].customer?'':'—'}}
                </div>
                <div :class="vipIndex==1&&selectIndex!=null?'td td-this':'td'" v-show="vipIndex==1">
                    <img src="https://liantaapi.lianta520.com/static/images/gou.png" mode="" v-if="vipEquityList[2].customer"/>
                    {{vipEquityList[2].customer?'':'—'}}
                </div>
            </div>
        </div>
        <div class="line"></div>
        
        <!-- <div class="pay">
            <div class="pay-title">
                <div class="pay-line"></div>
                支付方式
                <div class="pay-line"></div>
            </div>
            <div class="pay-content">
                <van-radio-group :value="radio" @change="onChange">
                    <van-cell data-name="1" @click="onClick('1')">
                        <div class="pay-l">
                            <img src="../../assets/images/icon01.png" alt="">
                            微信支付
                        </div>
                        <van-radio slot="right-icon" name="1" />
                    </van-cell>
                </van-radio-group>
            </div>
            <div class="line"></div>
        </div> -->
        <div class="btn">
            <van-button color="#FE4465" @click="handelPay">立即充值</van-button>
            <div class="pay-tip">
                充值即表示您同意恋TA
                <span @click="goAgree">
                    《充值协议》
                </span>
            </div>
        </div>


        <div v-show="showTip" id="weixinTip" ref="weixin" class="wxtip">
            <p class="wxtip-txt">
                第一步，点击右上角"..."
                <br />
                第二步，选择在浏览器打开
            </p>
            <img src="../../assets/images/icon06.png" alt="">
        </div>

        <!-- <a :href="payUrl" class>
            <p>baidu</p> 
        </a> -->
    </div>
</template>

<script>
import api from '../../api/main'
import wxPay from '../../utils/pay'
import store from '../../store'
import { Dialog,Toast} from 'vant';
import { isPhoneNumber } from '../../utils/index'
import wxOpen from '../../utils/getOpenId'
export default {
    name: 'index', 
    components: {
    },
    data () {
        return {
            radio:'2',
            phone:'',
            code:'',
            openId:'',
            token:'',
            userInfo:{},
            userInfoces:null,
            isWeixn:false,
            vipList:[],
            liandouList:[],
            vipEquityList:[{},{},{}],
            selectIndex:1,
            html:'',
            showTip:false,
            openid:'',
            captchaFont: '获取验证码',
            totalTime: 60,
            timer: null,
            rulesText: '',
            regCodeText:'',
            payUrl:'',
            imageCodeUrl:'',
            imageCode:'',
            fileName:'',
            vipIndex: 0,
        }
    },
    watch:{
        
    },
    created(){
        
    },
    mounted(){
        
        if(localStorage.getItem('token')){
            this.token = localStorage.getItem('token')
        }
        if(localStorage.getItem('userInfo')){
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        }else{
            this.userInfo = {}
        }
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.showTip = true;
        }
        
        this.queryVIP();
        this.getVipEquity();
        this.queryLianDou();
        this.is_weixn();
    },
    methods:{
        async getVipEquity(){
            let res = await api.GetVipEquity();
            this.vipEquityList = res.data.data;
        },
        vipIndexChange(type){
            this.vipIndex = type
            if(type==1){
                this.selectIndex = 4
            }else{
                this.selectIndex = 0
            }
        },
        async GetOpenId(code){
            let res = await api.GetOpenId(code);
            this.openid = res.data.data.openid
        },
        // goHref(){
        //     window.location.href = 'https://www.yrkjcs.com';
        // },
        goAgree(){
            window.location.href = 'https://www.yrkjcs.com/lrechargeAgree.html';
        },
        selectVIP(index){
            this.selectIndex = index
        },
        recharge(){
            Dialog({message: '暂不开放'});
        },
        async getImageCode(){
            let res = await api.GetImageCode();
            this.imageCodeUrl = res.data.data.imageCodeUrl;
            this.fileName = res.data.data.fileName;
        },
        // 获取vip套餐
        async queryVIP(){
            let res = await api.GetMembersAllow();
            this.vipList = res.data.data;
        },
        // 获取vip套餐
        async queryLianDou(){
            let res = await api.GetLianTaDouPricesAllow();
            this.liandouList = res.data.data;
        },
        
        //判断是否微信
        async is_weixn(){
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger'){
                this.isWeixn = true;
                // let code = await wxOpen.getUrlKey("code");
                // if(code){
                //     this.GetOpenId(code);
                // }else {
                //     wxOpen.getCodeApi("STATE");
                // }
            } else {
                this.isWeixn = false;
            } 
        },
        async handelPay() {
            if(!this.userInfo.nickName){
                Dialog({message: '请先登录'});
                return;
            }
            if(this.radio==1){
                if(this.isWeixn){
                    this.WeChatInPay()
                }else{
                    this.weChatPay();
                }

            }else if(this.radio==2){
                if(this.isWeixn){
                    this.showTip = true
                }else{
                    this.AliPay();
                }
            }
        },
        async AliPay(){
            let option = {
                // "subject": this.vipList[this.selectIndex].memberTime + '会员',
                // "device_info": "msmnile",
                // "memberVIPId": this.vipList[this.selectIndex].id,
                // "memberTime": this.vipList[this.selectIndex].memberTime,
                // "payType": 1
            }

            if(this.vipIndex!=2){
                option = {
                    "subject": this.vipList[this.selectIndex].memberTime + '会员',
					"device_info": "msmnile",
					"memberType": this.current==1?2:1,
					"memberTime": this.vipList[this.selectIndex].memberTime,
					"memberVIPId": this.vipList[this.selectIndex].id,
					"totalAmount": this.vipList[this.selectIndex].amount + '',
					"userId":this.userInfo.id,
					"phone":this.userInfo.phone,				
				}
            }else{
                option = {
					"subject": '恋豆',
					"device_info": "msmnile",
					"memberType": 0,
					"jinBiPriceId": this.liandouList[this.selectIndex].id,
					"totalAmount": this.liandouList[this.selectIndex].amount + '',
					"userId":this.userInfo.id,
					"phone":this.userInfo.phone,				
				}
            }
            let res = await api.AliPay(option);
            localStorage.setItem('form',res.data.data);
            this.$router.push({name: 'aliPay'});

        },
        async weChatPay(){
            let option = {
                
            }
            if(this.vipIndex!=2){
                option = {
					"description": this.vipList[this.selectIndex].memberTime + '会员',
					"device_info": "msmnile",
					"attach": this.vipList[this.selectIndex].memberTime,
					"memberType": this.current==1?2:1,
					"memberTime": this.vipList[this.selectIndex].memberTime,
					"memberVIPId": this.vipList[this.selectIndex].id,
					"total": this.vipList[this.selectIndex].amount,
					"userId":this.userInfo.id,
					"phone":this.userInfo.phone,				
					"openId":this.userInfo.openId,
				}
            }else{
                option = {
					"description": '恋豆',
					"device_info": "msmnile",
					"memberType": 0,
					"attach":this.liandouList[this.selectIndex].num+'个恋豆',
					"jinBiPriceId": this.liandouList[this.selectIndex].id,
					"total": this.liandouList[this.selectIndex].num,
					"userId":this.userInfo.id,
					"phone":this.userInfo.phone,				
					"openId":this.userInfo.openId,
				}
            }
            let res = await api.WeChatPay(option);
            window.location.replace(res.data.data)
        },

        async WeChatInPay(){
            let option = {
                "description": this.vipList[this.selectIndex].memberTime + '会员',
                "device_info": "msmnile",
                "attach": this.vipList[this.selectIndex].memberTime,
                "memberVIPId": this.vipList[this.selectIndex].id,
                "payType": 1,
                // "openid":'ozzl65uAvDwPFOVrxBQ8eyIHs11o',
                "openid":this.openid,
                
                "appid":'wx72d32521134c11ed'
            }
            let res = await api.JssdkUnifiedorder(option);
            wxPay.wxPay(res.data.data)
        },

        // 获取链接的key
        getUrlKey(name){
            return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
        },
        // 获取code
        async getCode(){ 
            const userInfo = this.getUrlKey("userInfo");
            // return;
            this.userInfoces = userInfo
            if(userInfo == null || userInfo == ''){
                window.location.href= 'http://47.112.123.229:8058/wxpay/#/WXOAuth/Index?returnUrl=my-server-note'
            }else{
                this.setOpenId(userInfo)
                localStorage.setItem('openid', userInfo)
            }
        },
        // 选择支付方式
        onClick(type){
            this.radio = type;
        },
        onChange(){},
        // 登录
        async login(){
            let res = await api.ACCOUNT_LOGIN({
                phone:this.phone,
                code:this.code
            });
            if(res.data.code == '200'){
                Dialog({message: '登录成功'});
                this.token = res.data.data.token;
                this.userInfo = res.data.data.userRes;
                localStorage.setItem('token',res.data.data.token);
                localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
                this.queryVIP();
            }else{
                Dialog({message: res.data.msg});
            }

        },
        // 切换账号
        close(){
            Dialog.confirm({
            title: '提示',
            message:
                '是否退出账号',
            })
            .then(() => {
                this.token = '';
                this.userInfo = {};
                localStorage.removeItem('token');
                localStorage.removeItem('userInfo');
            })
            .catch(() => {
            });
            
        },
        submitPay() {
          const data = {
            OrderID:this.id,
            openid:localStorage.getItem('openid')
          }
          api.wxPay(data).then((res) => {
            var dataList = JSON.parse(res.data);
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                  document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              }else if (document.attachEvent){
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            }else{
              onBridgeReady();
            }
                
            function onBridgeReady(){
              WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', {
                    "appId":dataList.appId,     //公众号名称，由商户传入     
                    "timeStamp":dataList.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr":dataList.nonceStr, //随机串     
                    "package":dataList.package,     
                    "signType":dataList.signType,         //微信签名方式：     
                    "paySign":dataList.paySign //微信签名 
                  },
                  function(res){
                        var temp =res.err_msg;
                        if(temp.indexOf('ok')>-1){
                        window.location.href = "http://wy.chezhuweishi.com/#/my-index"
                  } 
                  // if(res.err_msg == "get_brand_wcpay_request:ok" ){
                  // // 使用以上方式判断前端返回,微信团队郑重提示：
                  //       //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  //       // this.$router.push({name: 'my-server-note'})
                  //     // this.Dialog({message: '订单支付成功，请在服务记录中查看订单'})
                  //     window.location.href = "http://wy.chezhuweishi.com/#/my-index"
                  // } 
              }); 
            }
          }).catch((err)=>{
            

          });
        },

        async captchaButtonClick() {
            if(!isPhoneNumber(this.phone)){
                Toast({message: '注册账号不是手机号!'});
                return;
            }
            if (this.captchaFont != '获取验证码') return
            if (this.phone) {
            if (isPhoneNumber(this.phone)) {
                let res = await api.Send_Code({
                    phone:this.phone,
					imageCode: this.imageCode,
					fileName: this.fileName,
                });
                if(res.data.code == '200'){
                    this.code = res.data.Msg
                    this.countdown();
                }
            } else {
                
            }
            } else {
                
            }
        },
        // 倒计时
        countdown() {
            this.captchaFont = this.totalTime + '秒'
            this.timer = window.setInterval(() => {
            this.totalTime--
            this.rulesText = '验证码已发送'
            if (this.totalTime !== 0) {
                this.captchaFont = this.totalTime + '秒'
            } else {
                this.cleanTimer()
            }
            }, 1000)
        },
        cleanTimer() {
            window.clearInterval(this.timer)
            this.totalTime = 60
            this.captchaFont = '获取验证码'
            this.rulesText = ''
        },
    }
  
}
</script>

<style lang="scss" scoped>
    
    .line{
        width: 100%;
        height: 8px;
        background-color: #eeeeee;
    }
    .title{
        width: 690px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #FE4465;
        img{
            width: 40px;
            height: 40px;
            margin-right: 20px;
        }
    }
    .input{
        width: 690px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        margin-bottom: 30px;
        border:0px;
        border-color: #ffffff !important;
        padding-top: 28px;
        color: #333333;
        /deep/.van-cell{
            width: 480px;
            border:1px solid #FE4465;
            padding:15px;
            border-radius: 6px;
        }
        /deep/.van-button {
            height:70px
        }
        .input-code{
            display: flex;
            margin-top: 20px;
            .input-code-l{
                width: 250px;
                margin-right: 26px;
                /deep/.van-cell{
                    width: 240px;
                    flex: auto;
                }
                // /deep/.van-button--normal{
                //     min-width: 200px;
                // }
                
            }
            .item-code-img{
                width: 176px;
                height: 63px;
            }
            // /deep/.van-button::before{
            //     width: 200px;
            // }
        }
        .input-code-s{
            display: flex;
            justify-content: space-between;
            .codebtn{
                border-color: #ffffff !important;
            }
        }
    }
    .header{
        width: 750px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-size: 28px;
        justify-content: space-between;
        padding-right: 30px;
        border-top:2px solid #eeeeee;
        .header-l{
            display: flex;
            align-items: center;
            img{
                width: 120px;
                height: 120px;
                border-radius: 50%;
                margin: 30px;
            }
            .icon{
                width: 32px;
                height: 32px;
                margin-left: 12px;
                border-radius: 0;
            }
        }
        
    }
    .tip{
        width: 690px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .tip-line{
            width: 100%;
            height: 2px;
            background-color: #eeeeee;
        }
        .t-item{
            display: flex;
            align-items: center;
            height: 88px;
            width: 344px;
            font-size: 26px;
            color: #444444;
            span{
                color: #FE4465;
                margin-right: 10px;
            }
        }
        
    }
    .vip-title{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        height: 72px;
        color: #ffffff;
        margin-bottom: 30px;
        .vip-title-s{
            flex: 1;
            height: 72px;
            background-color: #FE4465;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .vip-title-i{
            flex: 1;
            height: 72px;
            background-color: #aaaaaa;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
        }   
        .vip-line{
            width: 100px;
            height: 1px;
            background-color: #222222;
        }
    }
    .vip-content{
        width: 720px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .vip-item{
            width: 206px;
            height: 200px;
            padding: 15px 0;
            border: 2px solid #cccccc;
            margin: 0 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            border-radius: 10px;
            margin-bottom: 30px;
            .vip-item1{
                font-size: 36px;
                color: #444444;
            }
            .vip-item2{
                font-size: 42px;
                color: #FE4465;
                font-weight: bold;
                margin-bottom: 4px;
            }
            .vip-item3{
                font-size: 28px;
                color: #444444;
            }
            .vip-item4{
                font-size: 25px;
                color: #444444;
                text-align: center;
            }
        }
        .vip-item-this{
            background-color: #fff0f0;
            border: 1px solid #FE4465;
        }
    }
    .pay{
        width: 750px;
        margin: 0 auto;
    }
    .pay-title{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        height: 88px;
        .pay-line{
            width: 100px;
            height: 1px;
            background-color: #222222;
            
        }   
        
    }
    .pay-l{
        display: flex;
        align-items: center;
        font-size: 32px;
        height: 70px;
        img{
            width: 60px;
            height: 60px;
            margin-right: 20px;
        }
    }
    .pay-tip{
        height: 70px;
        font-size: 24px;
        line-height: 24px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        span{
            color: #FE4465;
        }
    }
    .btn{
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
        // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
        width: 750px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        padding-top: 30px;
        padding-bottom: 10px;
        z-index: 100;
        /deep/.van-button{
            width: 500px;
            height: 80px;
        }
    }
    .index{
        position:relative;
        padding-bottom: 200px;
    }
    .wxtip {
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;

        img {
            width: 150px;
            height: 150px;
            position: absolute;
            right: 50px;
            top: 30px;
        }
    }

    .wxtip-txt {
        margin-top: 150px;
        color: #fff;
        font-size: 36px;
        line-height: 80px;
    }













    .tabel{
		width: 690px;
		margin-top: 0px;
		margin-left: 30px;
		background-color: #ffffff;
		border: 2px solid #eeeeee;
		border-radius: 10px;
		overflow: hidden;
	}
	.tr{
		display: flex;
		align-items: center;
		justify-content: center;
		align-items: center;
		font-size: 22px;
		background-color: #ffffff;
	}
	.tr2{
		background-color: #f9f9f9;
	}
	.th{
		flex: 1;
		height: 100px;
		color: #000000;
		background-color: #f4f4f4;
		text-align: center;
		line-height: 64px;
		transition: .3s;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		font-size: 28px;
	}
	.th-this{
		background-image: linear-gradient(to right, #ffd5ec , #ffb8d1);
		/* background-color: #ffd8e0; */
		color: #ff2950;
		opacity: .8;
		font-weight: 600;
		/* box-shadow: 0 4px 20px 0 rgba(31,9,73,.1); */
	}
	.td{
		flex: 1;
		width: 170px;
		height: 88px;
		color: #000000;
		padding: 10px;
		border-bottom:2px solid #f5f5f5;
		border-right:2px solid #f5f5f5;
		line-height: 32px;
		text-align: center;
		white-space:pre-line;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		transition: .3s;
		font-size: 26px;
	}
	.td-2{
		background-color: #fafafa;
	}
	.td text{
		font-size: 20px;
		color: #999999;
		margin-top: 4px;
	}
	.td-this{
		background-color: #ffeef9;
		color: #ff7f95;
		z-index: 2;
		/* box-shadow: 0 4px 20px 0 rgba(31,9,73,.1); */
	}
	.td2{
		flex: 1;
		width: 170px;
		color: #000000;
		padding: 10px;
		border-bottom:2px solid #f5f5f5;
		border-right:2px solid #f5f5f5;
		line-height: 40px;
		text-align: center;
		white-space:pre-line;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 90px;
		transition: .3s;
		font-size: 26px;
	}
	.tdh2{
		height: 180px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.tdh2-i{
		height: 90px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.tdh2-i span{
		font-size: 22px;
		color: #999999;
	}
	.tdh2-line{
		width: 230px;
		height: 2px;
		background-color: #f5f5f5;
	}
	.td2-this{
		background-color: #f9ebf2;
		color: #ff7f95;
	}
	.tr2 .td-this{
		background-color: #f9ebf2;
		color: #ff7f95;
	}

    .td img{
		width: 26px;
		height: 26px;
	}
	.td2 img{
		width: 26px;
		height: 26px;
	}
    .td .vipicon{
		width: 48px;
		height: 48px;
	}
	.td2 .vipicon{
		width: 48px;
		height: 48px;
	}
</style>
